import { Pipe, PipeTransform } from "@angular/core";
import { FinancialService } from "src/app/services/financial.service";

@Pipe( {
	name: "volumePrice"
} )

export class VolumePricePipe implements PipeTransform {

	constructor(
		private financialService: FinancialService
	) {
		this.financialService = financialService;
	}

	transform( value, ...args: unknown[] ) {

		if( args[0] ){
			const products: any = args[0];
			return this.financialService.getVolumePricesFromProducts( products );
		}


		return 0;
	}
}
